module.exports = "\n<a [routerLink]=\"[inputWhere]\"  >\n<i class=\"fa {{kind}} {{size}}\" aria-hidden=\"true\"></i>\n\t</a>\n"